import type { SyncFrequency } from './DataSourcesDirectory.types';

export { REGISTRY_SOURCES } from './registrySources';

export const REGION_ORDER = [
  'All',
  'Europe',
  'Americas',
  'United States',
  'Canada',
  'Asia',
  'Africa',
  'Middle East',
  'Oceania',
] as const;

type Translate = (key: string) => string;

export const getFrequencyLabel = (t: Translate): Record<SyncFrequency, string> => ({
  realtime: t('Real-time'),
  daily: t('Daily'),
  weekly: t('Weekly'),
  monthly: t('Monthly'),
});

export const PAGE_SIZE = 50;
